import type { ReactNode } from 'react';
import { VStack } from '@cbhq/cds-web/layout';

import type { ProductAccessRowConfig } from './ProductAccessRow';
import { ProductAccessRow } from './ProductAccessRow';

export type ProductAccessGroupProps = {
  rows: ProductAccessRowConfig[];
  footer?: ReactNode;
  showCheckbox?: boolean;
  isEditable?: boolean;
};

export function ProductAccessGroup({
  rows,
  footer,
  showCheckbox,
  isEditable = true,
}: ProductAccessGroupProps) {
  return (
    <VStack gap={2} width="100%">
      {rows.map((row) => (
        <ProductAccessRow
          key={row.productKey}
          {...row}
          showCheckbox={row.showCheckbox ?? showCheckbox}
          isEditable={row.isEditable ?? isEditable}
        />
      ))}
      {footer}
    </VStack>
  );
}
